import { render, staticRenderFns } from "./TimeWheel.vue?vue&type=template&id=3cdbf9a0&scoped=true&"
import script from "./TimeWheel.vue?vue&type=script&lang=js&"
export * from "./TimeWheel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cdbf9a0",
  null
  
)

export default component.exports